import(/* webpackMode: "eager", webpackExports: ["Banners"] */ "/opt/build/repo/app/_components/layout/navigation/banners/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SWRConfig"] */ "/opt/build/repo/app/_providers/SWRConfig.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/modules/CryptoConverterSmallCardBanner/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/modules/pdp-footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/pages/BlogRedesign/BlogHeader/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/components/pages/BlogRedesign/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Flex"] */ "/opt/build/repo/node_modules/@hubble/web/dist/esm/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
